import { Routes } from '@angular/router';

import { Route } from './core/Routes';
import { AppRoute } from './shared/app.route.enum';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: `/${AppRoute.Dashboard}`,
    pathMatch: 'full',
  },
  Route.withBaseLayoutAndAuthentication([
    {
      path: AppRoute.Forbidden,
      loadComponent: () => import('./core/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
      data: { title: 'Forbidden' },
    },
    {
      path: AppRoute.Dashboard,
      loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
      data: { title: 'Dashboard | Hypecast' },
    },
    {
      path: AppRoute.Analytics,
      loadChildren: () => import('./analytics/analytics.routes').then((m) => m.analyticsRoutes),
    },
    {
      path: AppRoute.Podcasts,
      loadChildren: () => import('./podcasts/podcasts.routes').then((m) => m.podcastsRoutes),
      data: { preload: true },
    },
    {
      path: AppRoute.Groups,
      loadChildren: () => import('./groups/groups.routes').then((m) => m.groupsRoutes),
    },
    {
      path: AppRoute.Users,
      loadChildren: () => import('./users/users.routes').then((m) => m.usersRoutes),
    },
    {
      path: AppRoute.Settings,
      loadChildren: () => import('./settings/settings.routes').then((m) => m.settingsRoutes),
    },
    {
      path: AppRoute.Studios,
      loadChildren: () => import('./meetings/meetings.routes').then((m) => m.meetingsRoutes),
      data: { preload: true },
    },
    {
      path: AppRoute.AudioAI,
      loadChildren: () => import('./audio-ai/audio-ai.routes').then((m) => m.audioAiRoutes),
    },
    {
      path: AppRoute.Editor,
      loadChildren: () => import('./editor/editor.routes').then((m) => m.editorRoutes),
    },
    {
      path: AppRoute.VideoEditor,
      loadChildren: () => import('./video-editor/video-editor.routes').then((m) => m.videoEditorRoutes),
      data: { preload: true },
    },
  ]),
];
